import React, { useState, useContext, useEffect } from 'react'
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import { ObjModal } from '../../../../contexts';
import AddLoan from '../../../Modals/Loan/add';
import DeleteLoan from '../../../Modals/Loan/delete';
import { FaRegTrashAlt } from 'react-icons/fa';

import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import { formatShorthand } from '../../../../common/utils';
import { removeLoan } from '../../../../common/api';
import { toast } from 'react-toastify';


const LoansV2 = ( { aid, uid, settings, contacts } ) => {
    const { obj, openModal, closeModal, setModal } = useContext( ObjModal );
    const [ expanded, setExpanded ] = useState( false );

    const formatName = ( cid ) => {
        const c = contacts[cid];
        if ( !c ) {
            return null;
        }
        let n = c.firstname;
        if ( c.namePreferred && c.namePreferred.length ) {
            n = c.namePreferred;
        }
        if ( c.lastname && c.lastname.length ) {
            n += ' ' + c.lastname;
        }
        
        return n.trim();
    };

    const formatDate = ( d ) => {
        if ( !d || !d.length ) {
            return 'Unknown';
        }

        let date = new Date( d );
        let now = new Date();
        let today = new Date( now.getFullYear(), now.getMonth(), now.getDate() );
        let yesterday = new Date( now.getFullYear(), now.getMonth(), now.getDate() - 1 );
    
        if ( date >= today ) {
            // If the date is today, return the time
            let hours = date.getHours();
            let minutes = date.getMinutes();
            let ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            minutes = minutes < 10 ? '0'+minutes : minutes;
            let strTime = hours + ':' + minutes + ' ' + ampm;
            return strTime;
        } else if ( date >= yesterday ) {
            // If the date is yesterday, return 'yesterday'
            return "Yesterday";
        } else {
            // If the date is prior to yesterday, return date in 'm/d/yy' format
            let year = date.getFullYear().toString().substr( -2 );
            let month = ( date.getMonth() + 1 ).toString();
            let day = date.getDate().toString();
    
            // Ensure double digit format
            month = month.length === 1 ? '0' + month : month;
            day = day.length === 1 ? '0' + day : day;
    
            return `${month}/${day}/${year}`;
        }
    }

    const formatBorrowerLinks = ( borrowers ) => {
        const links = [];
        for ( const b of borrowers ) {
            if ( b.cid !== obj.details.cid ) {
                const c = contacts[b.cid];
                links.push( c ? <Link to={`/contact/${b.cid}`}>{formatName( b.cid )}</Link> : 'Unknown' );
            }
        }
        return <span>{links.map( ( m, idx ) => <span className='pe-2' key={idx}>{m}</span> )}</span>;
    }

    const formatDateLine = ( l ) => {
        let line = '';

        if ( l.fileStartedDate ) {
            line = `File Started: ${formatDate(l.fileStartedDate)}`;
        } else {
            line = `File Created: ${formatDate(l.createdDate)}`;
        }

        switch ( l.status ) {
            case 'Funded':
            case 'Closed':
                line += ` - ${l.status}: ${formatDate( l.fundedDate ? l.fundedDate : l.statusChangeDate )}`;
                break;

            case 'Pre-Approved':
                line += ` - ${l.status}: ${formatDate( l.paDate ? l.paDate : l.statusChangeDate )}`;
                break;

            case 'Pre-Qual':
            case 'Pre-Qualified':
                line += ` - ${l.status}: ${formatDate( l.pqDate ? l.pqDate : l.statusChangeDate )}`;
                break;

            case 'In-Process':
            case 'In Contract':
                let d = l.contractDate ? l.contractDate : l.activeDate;
                if ( !d ) {
                    d = l.statusChangeDate;
                }
                line += ` - ${l.status}: ${formatDate( d )}`;
                break;

            case 'Cancelled':
                console.log( l.fileNum + ' - ' + l.cancelledDate + ' - ' + l.statusChangeDate );
                line += ` - ${l.status}: ${formatDate( l.cancelledDate ? l.cancelledDate : l.statusChangeDate )}`;
                break;

            case 'Credit Repair':
                line += ` - ${l.status}: ${formatDate( l.creditRepairDate ? l.creditRepairDate : l.statusChangeDate )}`;
                break;

            case 'Follow-Up':
            case 'Follow Up':
                line += ` - ${l.status}: ${formatDate( l.fuDate ? l.fuDate : l.statusChangeDate )}`;
                break;

            default:
                if ( l.statusChangeDate ) {
                    line += ` - ${l.status}: ${formatDate(l.statusChangeDate)}`;
                }
        }

        return line;
    }

    useEffect( () => {
        setExpanded( obj.loans.length > 0 );
        console.log( obj.loans)
    }, [ obj.loans ] );

    const trash = async ( laid, lid ) => {
        const removed = await removeLoan( laid, uid, lid );
        if ( removed.length ) {
            toast.success( `Your loan has been deleted`, { theme: 'dark' } );
            // window.location.reload( false );
        }
    };

    const handleModal = ( t, lid, name ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'loan':
                setModal( <AddLoan close={closeModal} /> ); 
                break;

            case 'delete':
                setModal( <DeleteLoan close={closeModal} lid={lid} name={name} /> );
                break;

            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const AccordionSummary = styled( ( props ) => (
        <MuiAccordionSummary expandIcon={<KeyboardArrowRightSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
    ) ) ( ( { theme } ) => ( {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    } ) );

    return (
        <Container fluid className='p-0'>
            <Accordion expanded={expanded}>
                <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setExpanded( !expanded ) } />}>
                    <Row className='align-items-center w-100'>
                        <Col><Typography>Loans ({obj.loans.length})</Typography></Col>
                        <Col xs='auto' className='p-0'><Button variant='outline-primary' size='sm' onClick={ () => handleModal( 'loan' ) }>+ Add</Button></Col>
                    </Row>
                </AccordionSummary>
                <AccordionDetails>
                    <ListGroup variant='flush' className='overflow-scroll' style={ { maxHeight: '400px' } }>
                    {
                        obj.loans.map( l => {
                            return (
                                <ListGroup.Item key={l.id}>
                                    <Row className='align-items-center'>
                                        <Col xs='auto' className='tf-sidebar-obj-value'>
                                        {
                                            ( l.status === 'Pre-Approved' && ( !settings || !settings.loan || !settings.loan.sidebar || !settings.loan.sidebar.paShowStatus ) ) ? (
                                                l.stage
                                            ) : (
                                                l.status
                                            )
                                        }
                                        </Col>
                                        <Col>
                                            <Row className='align-items-center'>
                                                <Col xs='auto' className='tf-sidebar-obj-key-date-container'>
                                                    <span className='tf-sidebar-obj-key-date'>
                                                        <Link to={`/loan/${l.lid}`}>{ l.fileNum ? l.fileNum : 'TBD' }</Link> - ${formatShorthand( l.amount )} - {l.purpose}
                                                    </span>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className='tf-sidebar-obj-desc'>
                                                    {formatDateLine( l )}
                                                </Col>
                                            </Row>
                                            {
                                                l.borrowers && l.borrowers.length > 1 ? (
                                                    <Row>
                                                        <Col className='tf-sidebar-obj-desc'>
                                                            Co-Borrowers: {formatBorrowerLinks( l.borrowers )}
                                                        </Col>
                                                    </Row>
                                                ) : (
                                                    null
                                                )
                                            }
                                        </Col>
                                        <Col xs='auto'><FaRegTrashAlt className='tf-sidebar-trash' onClick={ () => trash( l.aid, l.lid ) } /></Col>
                                    </Row>
                                </ListGroup.Item>
                            )
                        } )
                    }
                    </ListGroup>
                </AccordionDetails>
            </Accordion>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    settings: state.user.meta.settings,
    contacts: state.contacts.byId
} );

const mapDispatch = ( dispatch ) => ( {
    // loadTasks: dispatch.contacts.loadContactTasks,
} );

export default connect( mapProps, mapDispatch )( LoansV2 );